import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionCtl } from 'lib-klab-core';
import { hasAdminPortalAccess } from 'lib-klab-auth-ui';

export const noAuthGuard: CanActivateFn = () => {
    const router = inject(Router);
    const sessionCtl = inject(SessionCtl);

    if (!sessionCtl.loggedInCheckSync() || !hasAdminPortalAccess(sessionCtl.menu)) return true;

    return router.createUrlTree(['/admin']);
};
